// import { Colors } from '../../Configs';

const styles = {
  root: {
  },
};

export default styles;
